import { render, staticRenderFns } from "./CmsIndexDetails.vue?vue&type=template&id=4e176cc8&scoped=true"
import script from "./CmsIndexDetails.vue?vue&type=script&lang=ts"
export * from "./CmsIndexDetails.vue?vue&type=script&lang=ts"
import style0 from "./CmsIndexDetails.vue?vue&type=style&index=0&id=4e176cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e176cc8",
  null
  
)

export default component.exports